import { ReportTypeFilter, ReportTypeModel, ReportTypeParam } from './report-type-filters.types';

export const X_REPORT: ReportTypeModel = {
  title: ReportTypeFilter.X_REPORT, value: ReportTypeParam.X_REPORT, name: 'kkms.kkm.xreports', qaAttr: 'x-report',
};

export const Z_REPORT: ReportTypeModel = {
  title: ReportTypeFilter.Z_REPORT, value: ReportTypeParam.Z_REPORT, name: 'kkms.kkm.zreports', qaAttr: 'z-report',
};

export const IBERICA_REPORT: ReportTypeModel = {
  title: ReportTypeFilter.IBERICA_REPORT,
  value: ReportTypeParam.IBERICA_REPORT,
  name: 'analytics.filter.report.for.period',
  qaAttr: 'iberica',
};

export const REPORT_TYPE_FILTERS: ReportTypeModel[] = [
  X_REPORT,
  Z_REPORT,
  IBERICA_REPORT,
];
